import store from "./store/store";
import router from "./router.js";

export default (to, from, next) => {
  var graphqlError = localStorage.getItem("graphqlError")
    ? JSON.parse(localStorage.getItem("graphqlError"))
    : "";

  if (
    graphqlError.message == "Signature has expired" &&
    graphqlError.path.indexOf("getCurrentUser") != -1
  ) {
    store.dispatch("getNewToken");
  } else if (
    (graphqlError.message == "Signature has expired" &&
      graphqlError.path.indexOf("getNewAccessToken") != -1) ||
    graphqlError.message == "Only access tokens are allowed" ||
    !store.getters.user
  ) {
    // next({
    //     path: '/auth/signin'
    // });
    // added redirect path if before login coming from authentication non-required page

    router.push({ path: "/auth/signin", query: { redirect: to.fullPath } });
  } else {
    next();
  }
};
